var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header flex"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.logo}})]),_c('div',{staticClass:"login"},[_vm._v(" 已有账号,"),_c('router-link',{staticClass:"link",attrs:{"to":"login"}},[_vm._v("马上登录")]),_vm._v("| "),_c('router-link',{staticClass:"link",attrs:{"to":"home"}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }